import apiClient from "../api";

export const createPhones = async (phoneData) => {
    try {
        const token = await localStorage.getItem('token');

        const response = await apiClient.post("gestock/phones/create", phoneData,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const createGeneralProduct = async (productData) => {
    try {
        const token = await localStorage.getItem('token');
        const response = await apiClient.post("gestock/products/create", productData,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const sellPhone = async (phoneId, sellPhoneData) => {
    try {
        const token = await localStorage.getItem('token');
        const response = await apiClient.post(`gestock/phones/${phoneId}/sell`, sellPhoneData,
            {
                headers: { Authorization: `Bearer ${token}` },
            });
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};


export const deletePhones = async (supplierId, storeId) => {
    try {
        const response = await apiClient.delete(`gestock/suppliers/${supplierId}/${storeId}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const collectPayment = async (phoneId, storeId, amount, paymentMethod = "") => {
    try {
         const token = await localStorage.getItem('token');
        const response = await apiClient.post(`gestock/phones/${phoneId}/${storeId}/collect-payment`, { amount, paymentMethod },
            {
                headers: { Authorization: `Bearer ${token}` },
            });
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};


export const createExpense = async (storeId, payload) => {
    try {
        const token = await localStorage.getItem('token');
        const res = await apiClient.post(`/gestock/stores/${storeId}/expenses`, payload,
            {
                headers: { Authorization: `Bearer ${token}` },
            })
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}

export const createUser = async (storeId, payload) => {
    try {
        const token = await localStorage.getItem('token');
        const res = await apiClient.post(`/gestock/stores/${storeId}/users`, payload, {
            headers: { Authorization: `Bearer ${token}` },
        })
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}


export const toggleStatusUser = async (storeId, userId) => {
    try {
        const res = await apiClient.post(`/gestock/stores/${storeId}/users/${userId}/toggle`)
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}

/* ================= STORES ================= */
export const createStore = async (payload) => {
    try {
        const token = await localStorage.getItem('token');
        const res = await apiClient.post("/gestock/stores/create", payload,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
        return res.data
    } catch (error) {
        console.error("❌ createStore error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la création de la boutique",
        }
    }
}

export const toggleStoreStatus = async (storeId) => {
    try {
        const res = await apiClient.patch(
            `/gestock/stores/${storeId}/toggle`
        )
        return res.data
    } catch (error) {
        console.error("❌ toggleStoreStatus error:", error)
        throw error.response?.data || {
            message: "Erreur lors du changement de statut",
        }
    }
}

export const updateStore = async (storeId, payload) => {
    try {
        const token = await localStorage.getItem("token");
        const res = await apiClient.put(
            `/gestock/stores/${storeId}`,
            payload,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
        return res.data
    } catch (error) {
        console.error("❌ updateStore error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la mise à jour de la boutique",
        }
    }
}

export const syncGoogleStoreReviews = async (storeId, payload = {}) => {
    try {
        const token = await localStorage.getItem("token");
        const res = await apiClient.post(
            `/gestock/stores/${storeId}/reviews/google-sync`,
            payload,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
        return res.data
    } catch (error) {
        console.error("❌ syncGoogleStoreReviews error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la synchronisation des avis Google",
        }
    }
}

export const changeActiveStore = async (storeId) => {
    try {
        const token = await localStorage.getItem('token');
        const res = await apiClient.put("/gestock/user/me/store", { storeId },
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
        return res.data
    } catch (error) {
        console.error("❌ change active store error:", error)
        throw error.response?.data || {
            message: "Erreur lors du changement de boutique",
        }
    }
}




// STOCK

export const getStockSummary = async (
  storeId,
  params
) => {
  const token = localStorage.getItem("token")
  const q = params?.q ?? ""
  const lowOnly = params?.lowOnly ? "1" : "0"
  const threshold = params?.threshold ?? 2
  const page = params?.page ?? 1
  const limit = params?.limit ?? 10

  const res = await apiClient.get(
    `/gestock/products/${storeId}/stock/summary?q=${encodeURIComponent(q)}&lowOnly=${lowOnly}&threshold=${threshold}&page=${page}&limit=${limit}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return res.data
}

export const getStockItemsByModel = async (storeId, model) => {
  const token = localStorage.getItem("token")
  const res = await apiClient.get(
    `/gestock/products/${storeId}/stock/items?model=${encodeURIComponent(model)}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
  return res.data
}


export const createProductCatalog = async (payload) => {
  const token = localStorage.getItem("token")
  const res = await apiClient.post(
    "/gestock/products/create",
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return res.data
}

export const addInventoryItem = async (storeId, payload) => {
  const token = localStorage.getItem("token")
  const res = await apiClient.post(
    `/gestock/products/${storeId}/inventory`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return res.data
}

export const createGeneralProduct1 = async (payload) => {
  try {
    const token = localStorage.getItem("token")

    const res = await apiClient.post(
      "/gestock/products/create",
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    return res.data
  } catch (error) {
    console.error("❌ createGeneralProduct error:", error)
    throw error.response?.data || error
  }
}

const resolveSignedUploadData = (data = {}) => {
  const uploadUrl =
    data?.uploadUrl ||
    data?.signedUrl ||
    data?.url ||
    data?.presignedUrl ||
    data?.presignedPost?.url

  const publicUrl =
    data?.fileUrl ||
    data?.publicUrl ||
    data?.assetUrl ||
    data?.location ||
    data?.uploadedUrl

  const fields = data?.fields || data?.presignedPost?.fields || null
  const fileKey = data?.fileKey || data?.key || data?.objectKey || data?.s3Key || ""

  return { uploadUrl, publicUrl, fields, fileKey }
}

export const uploadVehicleVideoToS3 = async (file, storeId) => {
  try {
    if (!file) {
      throw new Error("Aucune video selectionnee")
    }

    const token = localStorage.getItem("token")
    const formData = new FormData()
    formData.append("video", file)
    formData.append("storeId", String(storeId || ""))

    const uploadRes = await fetch(`${apiClient.defaults.baseURL}gestock/uploads/vehicle-video`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })

    const payload = await uploadRes.json().catch(() => ({}))

    if (!uploadRes.ok) {
      throw payload || new Error("Erreur upload video")
    }

    const data = payload?.data || payload || {}
    const { publicUrl, fileKey } = resolveSignedUploadData(data)

    return {
      videoUrl: publicUrl || data?.videoUrl || "",
      videoKey: fileKey || data?.videoKey || "",
    }
  } catch (error) {
    throw error?.response?.data || error
  }
}

export const uploadServiceShowcaseVideoToS3 = async (file, storeId) => {
  try {
    if (!file) {
      throw new Error("Aucune video selectionnee")
    }

    const token = localStorage.getItem("token")
    const formData = new FormData()
    formData.append("video", file)
    formData.append("storeId", String(storeId || ""))

    const uploadRes = await fetch(`${apiClient.defaults.baseURL}gestock/uploads/service-showcase-video`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })

    const payload = await uploadRes.json().catch(() => ({}))

    if (!uploadRes.ok) {
      throw payload || new Error("Erreur upload video")
    }

    const data = payload?.data || payload || {}
    const { publicUrl, fileKey } = resolveSignedUploadData(data)

    return {
      videoUrl: publicUrl || data?.videoUrl || "",
      videoKey: fileKey || data?.videoKey || "",
    }
  } catch (error) {
    throw error?.response?.data || error
  }
}

export const uploadVehicleCoverImageToS3 = async (file, storeId) => {
  try {
    if (!file) {
      throw new Error("Aucune image selectionnee")
    }

    const token = localStorage.getItem("token")
    const formData = new FormData()
    formData.append("image", file)
    formData.append("storeId", String(storeId || ""))

    const uploadRes = await fetch(`${apiClient.defaults.baseURL}gestock/uploads/vehicle-cover-image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })

    const payload = await uploadRes.json().catch(() => ({}))

    if (!uploadRes.ok) {
      throw payload || new Error("Erreur upload image")
    }

    const data = payload?.data || payload || {}

    return {
      coverImageUrl: data?.coverImageUrl || data?.imageUrl || "",
      imageUrl: data?.imageUrl || data?.coverImageUrl || "",
      coverImageKey: data?.coverImageKey || data?.imageKey || "",
    }
  } catch (error) {
    throw error?.response?.data || error
  }
}

export const uploadVehicleCarImagesToS3 = async (files, storeId) => {
  const imageFiles = Array.isArray(files) ? files.filter(Boolean) : []

  if (!imageFiles.length) {
    throw new Error("Aucune image selectionnee")
  }

  return Promise.all(
    imageFiles.map((file) => uploadVehicleCoverImageToS3(file, storeId))
  )
}

export const sellGeneralProduct = async (storeId, productId, payload) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.post(
      `/gestock/stores/${storeId}/products/${productId}/sell`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ sellGeneralProduct error:", error)
    throw error.response?.data || error
  }
}

export const collectGeneralPayment = async (storeId, saleId, amount, paymentMethod = "") => {
  try {
    const token = await localStorage.getItem("token")

    const response = await apiClient.post(
      `/gestock/stores/${storeId}/general/sales/${saleId}/collect`,
      { amount, paymentMethod },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    return response.data
  } catch (error) {
    console.log({ error })
    throw error.response?.data || error
  }
}

export const deleteGeneralSale = async (storeId, saleId) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.delete(
      `/gestock/stores/${storeId}/general/sales/${saleId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ deleteGeneralSale error:", error)
    throw error.response?.data || error
  }
}

export const deletePhoneSale = async (phoneId, storeId) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.delete(
      `/gestock/phones/${phoneId}/${storeId}/sale`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ deletePhoneSale error:", error)
    throw error.response?.data || error
  }
}

export const updateGeneralSale = async (storeId, saleId, payload) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.put(
      `/gestock/stores/${storeId}/general/sales/${saleId}`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ updateGeneralSale error:", error)
    throw error.response?.data || error
  }
}

export const updatePhoneSale = async (phoneId, storeId, payload) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.put(
      `/gestock/phones/${phoneId}/${storeId}/sale`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ updatePhoneSale error:", error)
    throw error.response?.data || error
  }
}

export const updateGeneralProduct = async (storeId, productId, payload) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.put(
      `/gestock/stores/${storeId}/products/${productId}`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ updateGeneralProduct error:", error)
    throw error.response?.data || error
  }
}

export const deleteGeneralProduct = async (storeId, productId) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.delete(
      `/gestock/stores/${storeId}/products/${productId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ deleteGeneralProduct error:", error)
    throw error.response?.data || error
  }
}

export const createGestockAdVideo = async (storeId, productId, payload) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.post(
      `/gestock/stores/${storeId}/products/${productId}/ad-videos`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ createGestockAdVideo error:", error)
    throw error.response?.data || error
  }
}

export const getGestockAdVideos = async (storeId, params = {}) => {
  try {
    const token = localStorage.getItem("token")
    const query = new URLSearchParams()
    if (params.productId) query.set("productId", params.productId)

    const suffix = query.toString() ? `?${query.toString()}` : ""
    const res = await apiClient.get(
      `/gestock/stores/${storeId}/ad-videos${suffix}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ getGestockAdVideos error:", error)
    throw error.response?.data || error
  }
}

export const getGestockAdVideo = async (storeId, videoId) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.get(
      `/gestock/stores/${storeId}/ad-videos/${videoId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ getGestockAdVideo error:", error)
    throw error.response?.data || error
  }
}

export const deleteGestockAdVideo = async (storeId, videoId) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.delete(
      `/gestock/stores/${storeId}/ad-videos/${videoId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.error("❌ deleteGestockAdVideo error:", error)
    throw error.response?.data || error
  }
}
